import React, {Component} from 'react';
import {images} from 'assets/img/dashboard/buy-and-sell/buy-and-sell';
import {MoneyField} from "buenLib/components/MoneyField";
import {BadgeRate} from "components/dashboard/common/BadgeRate";
import 'assets/sass/dashboard/home/Balances.scss';
import { AppContext } from 'app/state/AppContext';

export class BalanceItem extends Component {
    static contextType = AppContext;

    render() {
        let currency = this.props.currency;
        const { getCurrencyInstance } = this.context;

        return (
            <div className={`${currency}-balance`}>
                <div className="balance-title">
                    <img className="icon-currency" src={images[`${currency}Ball`]} alt={getCurrencyInstance(currency).code()}/>
                    <span className="currency-name">{getCurrencyInstance(currency).asVerbose()}</span>
                </div>
                <div className="balance-amount">
                    <div className="price">
                        <MoneyField value={this.props.balance} currency={currency}/>
                    </div>
                    <div className="label">{getCurrencyInstance(currency).code()}</div>
                </div>
                {/*{this.renderAnnualProfitabilityFor(this.props.data.ars_annual_profitability)}*/}
            </div>
        );
    }

    renderAnnualProfitabilityFor(annualProfitabilityValue) {
        return (
            <div className="balance-performance">
                Rendimiento anual estimado {this.renderBadgeRateFor(annualProfitabilityValue)}
            </div>
        )
    }

    renderBadgeRateFor(aValue) {
        let absValue = Math.abs(aValue);
        return <BadgeRate type={this._budgetRateTypeFor(aValue)}>{absValue.toLocaleString()}%</BadgeRate>
    }

    _budgetRateTypeFor(aValue) {
        if (aValue > 0) {
            return "up";
        } else {
            return "down"
        }
    }
}
